import { countriesList } from '../services/countriesList';
import { ICountryDetail, IListType } from '../types/countries';
import { displayErrorNotification } from './displayNudosStandardNotifications';

const getListOfCountriesByOfferedService = async (
  setListOfCountries?: React.Dispatch<React.SetStateAction<ICountryDetail[] | undefined>>,
  offeredService?: IListType
) => {
  try {
    const completeListOfCountries = await countriesList(offeredService);
    setListOfCountries && setListOfCountries(completeListOfCountries);
    return completeListOfCountries;
  } catch (error) {
    displayErrorNotification();
  }
};

const getCountryDataFromCode = (countryCode?: string, listOfCountries?: ICountryDetail[]) => {
  if (!listOfCountries || !countryCode) return;
  const countryData = listOfCountries.find(country => country.code === countryCode);
  return countryData;
};

const getCountryDataFromCountryId = (countryId: number, listOfCountries: ICountryDetail[]) => {
  if (!listOfCountries) return;
  const countryData = listOfCountries.find(country => country.id === countryId);
  return countryData;
};

export { getListOfCountriesByOfferedService, getCountryDataFromCode, getCountryDataFromCountryId };
